<template>
  <div>
    <!-- 头部 -->

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.Name" placeholder="请输入车辆名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleadd()">添加车辆</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      class="elTable"
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%;"
    >
      <el-table-column align="center" prop="ID" label="ID" width="80"></el-table-column>

      <el-table-column align="center" prop="Name" label="车辆名称" width="250"></el-table-column>
      <el-table-column align="center" prop="car_num" label="车牌号" width="250"></el-table-column>
      <el-table-column align="center" prop="car_count" label="车辆编号" width="250"></el-table-column>
      <el-table-column align="center" prop="editTime" label="创建时间" width="250">
        <template slot-scope="scope">
          <div>{{ scope.row.editTime | timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="note" label="备注" width="250"></el-table-column>
      <el-table-column align="center" fixed="right" label="操作" min-width="250">
        <template slot-scope="scope">
  
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" round>编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)" round>删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form
        style="padding-right:9%"
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="车辆名称" prop="Name">
          <el-input size="small" v-model="editForm.Name" auto-complete="off" placeholder="请输入车辆名称"></el-input>
        </el-form-item>
        <el-form-item label="车牌号" prop="car_num">
          <el-input
            size="small"
            v-model="editForm.car_num"
            auto-complete="off"
            placeholder="请输入车牌号"
          ></el-input>
        </el-form-item>
        <el-form-item label="车辆编号" prop="car_count">
          <el-input
            size="small"
            v-model="editForm.car_count"
            auto-complete="off"
            placeholder="请输入车辆编号"
          ></el-input>
        </el-form-item>

        <el-form-item label="创建时间" required>
          <el-col :span="11">
            <el-form-item prop="date1">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="editForm.date1"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-form-item prop="date2">
              <el-time-picker placeholder="选择时间" v-model="editForm.date2" style="width: 100%;"></el-time-picker>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item label="备注" prop="type">
          <el-input
            type="textarea"
            size="small"
            v-model="editForm.type"
            auto-complete="off"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
        >保存</el-button>
      </div>
    </el-dialog>
    <!-- 添加车辆 -->
    <el-dialog title="车辆数据" :visible.sync="outerVisible" width="70%" :close-on-click-modal="false">
      <el-form :inline="true" :model="importInline">
        <el-form-item label="车辆编号">
          <el-input size="small" v-model="importInline.car_id" placeholder="输入车辆编号"></el-input>
        </el-form-item>
        <el-form-item label="车牌号">
          <el-input size="small" v-model="importInline.car_number" placeholder="输入车牌号"></el-input>
        </el-form-item>
        <el-form-item label="车辆型号">
          <el-select
            size="small"
            v-model="importInline.car_type"
            clearable
            @click="onClickImport()"
            placeholder="输入车辆型号"
          >
            <el-option
              v-for="item in car_types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="searchCar">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="addImport">确 定</el-button>
          <el-button size="small" @click="outerVisible = false">取 消</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="gridData"
        @selection-change="handleSelectionChange"
        ref="multipleTable"
        row-key="id"
      >
        <el-table-column width="50" type="selection" reserve-selection></el-table-column>
        <el-table-column align="center" width="50" property="id" label="ID"></el-table-column>
        <el-table-column align="center" width="100" property="car_id" label="车辆编号"></el-table-column>
        <el-table-column align="center" width="200" property="name" label="名称"></el-table-column>
        <el-table-column align="center" width="100" property="car_number" label="车牌号"></el-table-column>
        <!-- <el-table-column align="center" width="150" property="car_type" label="车辆型号"></el-table-column> -->
        <!-- <el-table-column align="center" width="100" property="retedVoltage" label="额定电压"></el-table-column>
        <el-table-column width="100" align="center" property="car_battery_capacity" label="电池容量"></el-table-column>
        <el-table-column width="100" align="center" property="car_motor_power" label="电机功率"></el-table-column>
        <el-table-column width="100" align="center" property="car_max_speed" label="最大车速"></el-table-column>
        <el-table-column width="120" align="center" property="retedLoadmass" label="额定载质量"></el-table-column>
        <el-table-column property="car_curb_weight" label="整备质量" width="100" align="center"></el-table-column>
        <el-table-column property="manufacturing_date" width="150" align="center" label="制造日期"></el-table-column>
        <el-table-column width="100" align="center" property="car_color" label="车身颜色"></el-table-column>
        <el-table-column property="status" width="100" align="center" label="车辆状态"></el-table-column>
        <el-table-column width="150" align="center" property="data_source" label="数据来源"></el-table-column>-->
        <el-table-column width="400" align="center" property="car_comment" label="备注"></el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagetwo.currentPage"
          :page-sizes="[5, 10, 15, 25, 50, 100]"
          :page-size="pagetwo.pageSize"
          background
          :pager-count="5"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagetwo.total"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import Pagination from "../../components/Pagination";
export default {
  name: "car",
  data() {
    return {
      activeName: "first",
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      outerVisible: false,
      title: "添加",
      car_types: [],
      gridData: [],
      importInline: {
        id: '',
        car_id: "",
        car_type: "",
        car_number: "",
        page: 1,
        limit: 10
      },
      pagetwo: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      editForm: {
        ID: "",
        Name: "",
        car_num: "",
        car_count: "",
        note: "",
        date1: "",
        date2: "",
        token: localStorage.getItem("logintoken")
      },
      // rules表单验证
      rules: {
        Name: [{ required: true, message: "请输入车辆名称", trigger: "blur" }],
        car_num: [{ required: true, message: "请输入车牌号", trigger: "blur" }],
        car_count: [
          { required: true, message: "请输入车辆编号", trigger: "blur" }
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change"
          }
        ]
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: "",
        varName: "",
        token: localStorage.getItem("logintoken")
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken")
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    };
  },

  // 注册组件
  components: {
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleadd() {
      this.outerVisible = true
    },
    addImport() {

    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true;
      // 模拟数据开始
      let res = {
        code: 0,
        msg: null,
        count: 5,
        data: [
          {
            ID: 1005,
            Name: "测试测试",
            car_num: "测试测试",
            car_count: "测试测试",
            addTime: 1526453107000,
            editTime: 1526453107000,
            note: "测试测试",
            parentId: 1
          },
          {
            ID: 1005,
            Name: "测试测试",
            car_num: "测试测试",
            car_count: "测试测试",
            addTime: 1526453107000,
            editTime: 1526453107000,
            note: "测试测试",
            parentId: 1
          },
          {
            ID: 1005,
            Name: "测试测试",
            car_num: "测试测试",
            car_count: "测试测试",
            addTime: 1526453107000,
            editTime: 1526453107000,
            note: "测试测试",
            parentId: 1
          }
        ]
      };
      this.loading = false;
      this.listData = res.data;
      this.pageparm.currentPage = this.formInline.page;
      this.pageparm.pageSize = this.formInline.limit;
      this.pageparm.total = res.count;
      // 模拟数据结束

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      // deptList(parameter)
      //   .then(res => {
      //     this.loading = false
      //     if (res.success == false) {
      //       this.$message({
      //         type: 'info',
      //         message: res.msg
      //       })
      //     } else {
      //       this.listData = res.data
      //       // 分页赋值
      //       this.pageparm.currentPage = this.formInline.page
      //       this.pageparm.pageSize = this.formInline.limit
      //       this.pageparm.total = res.count
      //     }
      //   })
      //   .catch(err => {
      //     this.loading = false
      //     this.$message.error('菜单加载失败，请稍后再试！')
      //   })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = this.parm.currentPage;
      this.formInline.limit = this.parm.pageSize;
      this.getdata(this.formInline);
    },
    handleSelectionChange() {

    },
    handleSizeChange(){

    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.editForm.deptId = row.deptId;
        this.editForm.deptName = row.deptName;
        this.editForm.deptNo = row.deptNo;
      } else {
        this.title = "添加";
        this.editForm.deptId = "";
        this.editForm.deptName = "";
        this.editForm.deptNo = "";
      }
    },
    handleCurrentChange(){

    },
    searchCar() {
      this.carInline.page = 1;
      // this.getCarData();
    },
    // 编辑、增加页面保存方法
   /*  submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          deptSave(this.editForm)
            .then(res => {
              this.editFormVisible = false;
              this.loading = false;
              if (res.success) {
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "保存成功！"
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.msg
                });
              }
            })
            .catch(err => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("保存失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    }, */
    // 删除公司
 /*    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "已删除!"
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg
                });
              }
            })
            .catch(err => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }, */
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    }
  }
};
</script>
<style scoped>
.elTable /deep/ td {
  padding: 0.5% 0 !important;
}

.head {
  width: 99%;
  padding-bottom: 1%;
  margin-top: 1%;
  margin-left: 1%;
  font-size: 20px;
  color: #334157;
  border-bottom: 1px solid #f5f5f5;
}

el-tabs {
  margin-left: 1%;
}

.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/area_mn/area_car.vue